const renameConversation = (state, action) => {
  switch (action.status) {
    case 'started':
      return {
        ...state,
        renamingConversation: true,
      };
    case 'success':
    case 'error':
      return {
        ...state,
        renamingConversation: false,
      };
    default:
      return state;
  }
};

export default renameConversation;
